import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddWoodTypeLayer from "../components/AddWoodTypeLayer";


export const AddWoodTypePage = () => {
  return (
    <MasterLayout>
      <AddWoodTypeLayer/>
    </MasterLayout>
  );
};
